<template>
  <div class="web-assistant-launcher">
    <button
      class="web-assistant-launcher__button"
      :style="{ backgroundColor: backgroundColour }"
      @click="emit('buttonClick')"
    >
      <svg class="app-icon" v-if="!isOpen" :style="{ fill: iconColour }">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#web-assistant"></use>
      </svg>
      <svg class="close-icon" :style="{ stroke: iconColour }" v-else>
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#cross" />
      </svg>
    </button>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  backgroundColour: {
    type: String,
  },
  iconColour: {
    type: String,
  },
});

const emit = defineEmits<{
  (e: 'buttonClick'): void;
}>();
</script>

<style lang="scss" scoped>
.web-assistant-launcher {
  &__button {
    width: 4rem;
    height: 4rem;
    border-radius: 50em;
    right: 0.5em;
    bottom: 0.5em;
    margin-top: 14px;
    margin-left: auto;
    cursor: pointer;
    box-shadow: 0 3px 8px 0 rgb(0 0 0 / 20%);
    transition: 300ms;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    svg {
      width: 3rem;
      height: 2.3rem;
      margin-top: 3px;

      &.close-icon {
        width: 1.5rem;
        height: 1.5rem;
      }
    }

    &:hover {
      box-shadow: 0 3px 8px 0 rgb(0 0 0 / 30%);
    }
  }
}
</style>
